import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { useBoundStore } from 'useStore';
import fetchForecastGeneralData from '../services/fetchForecastGeneralData';
import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';
import useCountriesData from 'views/Components/Shared/Queries/countriesQuery';

export default function useForecastGeneralData() {
	const { accessToken } = useAuth();
	const countriesQuery = useCountriesData();
	const currentMasterCountry = useCurrentMasterCountry();
	const countryId = currentMasterCountry?.id;

	const paginationModel = useBoundStore((state) => state.fgPaginationModel);
	const selectedOwner = useBoundStore((state) => state.fgSelectedOwner);
	const selectedYear = useBoundStore((state) => state.fgSelectedYear);
	const search = useBoundStore((state) => state.fgSearch);
	const selectedMarketplace = useBoundStore(
		(state) => state.fgSelectedMarketplace
	);

	const forecastGeneralQuery = useQuery({
		queryKey: [
			'forecastGeneral',
			{
				offset: paginationModel.page,
				limit: paginationModel.pageSize,
				countryId,
				ownerId: selectedOwner,
				year: selectedYear,
				search,
				marketplaceId: selectedMarketplace,
			},
		],
		queryFn: () =>
			fetchForecastGeneralData({
				accessToken,
				offset: paginationModel.page,
				limit: paginationModel.pageSize,
				countryId,
				ownerId: selectedOwner,
				year: selectedYear,
				search,
				marketplaceId: selectedMarketplace,
			}),

		staleTime: Infinity,
		retry: false,
		enabled: !!countryId && !!selectedYear,
		placeholderData: (previousData) => {
			return previousData;
		},
	});

	if (countriesQuery.isError) {
		throw countriesQuery.error;
	}

	return forecastGeneralQuery;
}
